import { computed } from 'vue'
import { useCurrencyStore } from '@/stores/CurrencyStore'

export default function currencyStore ({ store, pinia }) {
  store.$currency = computed(() => {
    const store = useCurrencyStore(pinia)

    return store.currency
  })
}